import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { ReportsPage } from "@/components/site/ReportsPage";
import { pageSchemas, reportListSchemas } from "@/lib/seo/page-schema";
import { REPORTS } from "@/content/reports";

type ReportsSearch = { year?: string; topic?: string; role?: string };

export const Route = createFileRoute("/reports/")({
  validateSearch: (raw: Record<string, unknown>): ReportsSearch => {
    const year = typeof raw.year === "string" && raw.year ? raw.year : undefined;
    const topic = typeof raw.topic === "string" && raw.topic ? raw.topic : undefined;
    const role = typeof raw.role === "string" && raw.role ? raw.role.slice(0, 20) : undefined;
    return { year, topic, role };
  },
  head: () => ({
    meta: [
      { title: "Reports - Media Intelligence & Market Research | Perceptica" },
      { name: "description", content: "Free media intelligence reports from Perceptica covering market research, reputation analysis, crisis monitoring and competitive intelligence in SEE." },
      { property: "og:title", content: "Reports - Media Intelligence & Market Research | Perceptica" },
      { property: "og:description", content: "Free media intelligence reports from Perceptica covering market research, reputation analysis, crisis monitoring and competitive intelligence in SEE." },
      { property: "og:type", content: "website" },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Reports - Media Intelligence & Market Research | Perceptica" },
      { name: "twitter:description", content: "Free media intelligence reports from Perceptica covering market research, reputation analysis, crisis monitoring and competitive intelligence in SEE." },
      { property: "og:url", content: "https://perceptica.com/reports" },
      ...ogImageMeta("en", "/reports"),
    ],
    scripts: [
      ...pageSchemas({
      locale: "en",
      path: "/reports/index",
      service: {
        name: "Custom media research and sector reporting",
        description:
          "Perceptica designs and delivers custom media research and sector reports for communications, marketing and strategy teams across Southeast Europe.",
        serviceType: "Custom Media Research & Sector Reporting",
        category: "Media analysis",
      },
      collection: { name: "Perceptica reports", description: "Original research from Perceptica" },
      }),
      ...reportListSchemas({ locale: "en", reports: REPORTS }),
    ],
  }),
  component: ReportsPage,
});
